export function numberToWords(value: number) {
  const underTwenty = ["Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty"];
  if (value < 20) return underTwenty[value] ?? String(value);
  const tensDigit = Math.floor(value / 10);
  const onesDigit = value % 10;
  return `${tens[tensDigit] ?? String(value)}${onesDigit ? ` ${underTwenty[onesDigit]}` : ""}`;
}

export function getRankedRoundForPlayer(playerId: string, rankingIds: string[], teams: number, rounds: number) {
  const index = rankingIds.indexOf(playerId);
  if (index < 0 || teams <= 0) return rounds;
  return Math.min(rounds, Math.floor(index / teams) + 1);
}

export function arraysEqual(left: string[], right: string[]) {
  if (left.length !== right.length) return false;
  for (let index = 0; index < left.length; index += 1) {
    if (left[index] !== right[index]) return false;
  }
  return true;
}

export function normalizeDraftAssignSearch(value: string) {
  return value
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[^\p{L}\p{N}\s]/gu, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function isReverseRound(roundIndex: number, style: "Snake Draft" | "Regular Draft" | "Third Round Reversal") {
  if (style === "Regular Draft") return false;
  if (style === "Snake Draft") return roundIndex % 2 === 1;
  return roundIndex === 1 || (roundIndex >= 2 && roundIndex % 2 === 0);
}
